import { render, staticRenderFns } from "./ProductDetailGroup.vue?vue&type=template&id=13f0602a&scoped=true&"
import script from "./ProductDetailGroup.vue?vue&type=script&lang=js&"
export * from "./ProductDetailGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailGroup.vue?vue&type=style&index=0&id=13f0602a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0602a",
  null
  
)

export default component.exports